import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import MenuItem from '@material-ui/core/MenuItem';
import { stringToColor, getInitials } from 'ui-utils';

const styles = (theme) => ({
  avatar: {
    color: `${theme.palette.common.white} !important`,
    fontSize: theme.custom.fontSizes.bodyS,
    marginRight: theme.spacing.unit * 2,
  },
  menuItem: {
    fontSize: theme.custom.fontSizes.small,
    fontWeight: 500,
  },
});

class CustomPatientOption extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (event) => {
    const { onSelect, option } = this.props;

    onSelect(option, event);
  };

  render() {
    const { classes, isSelected, onFocus, onSelect, option } = this.props;
    const [name, dob, updatedAt] = option.label.split('||');
    const initials = getInitials(name);
    const backgroundColor = stringToColor(name);

    return (
      <MenuItem
        className={classes.menuItem}
        component="div"
        onClick={(event) => onSelect(option, event)}
        onFocus={onFocus}
        selected={isSelected}
      >
        <Avatar className={classes.avatar} size={35} style={{ backgroundColor }}>
          {initials}
        </Avatar>
        {`${name}${dob !== '' ? ` - ${dob}` : ''}${updatedAt !== '' ? ` - Last edited ${updatedAt}` : ''}`}
      </MenuItem>
    );
  }
}

CustomPatientOption.propTypes = {
  classes: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
};

export default withStyles(styles)(CustomPatientOption);
